import React from 'react';
import zxcvbn from 'zxcvbn';


class PasswordFieldComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pwVisible: false
        };
    }

    togglePwVisibility() {
        this.setState({
            pwVisible: !this.state.pwVisible
        });
    }

    onChange(e) {
        const value = e.target.value;
        const strengthBar = React.findDOMNode(this.refs.meter);

        const strength = Math.min(zxcvbn(value)['score'], 4);

        // Remove old strength
        // At least Firefox & Chrome support remove-ing many at once, should problems arise, split this up.
        strengthBar.classList.remove('strength-1', 'strength-2', 'strength-3', 'strength-4');

        //Add new strength
        strengthBar.classList.add('strength-' + strength);
        this.props.onChange(value);
    }

    renderField(){
        return <input className="form-control" placeholder={this.props.label} type={this.state.pwVisible ? 'text' : 'password'} onChange={this.onChange.bind(this)}/>
    }

    renderMeter(){
        if (this.props.showMeter === true){
            return (
                <div className="password-strength-container strength-0" ref="meter">
                    <span className="password-strength-text">Password strength</span>
                    <div className="password-strength-bar-container">
                        <div className="password-strength-bar"></div>
                    </div>
                </div>
            );
        }
        return;
    }

    render () {
        return (
            <label className='form-control form-control-password'>
                {this.renderField()}
                {this.props.error ? <span className="error-block">{this.props.error}</span> : ''}
                <div className="show-pw" onClick={this.togglePwVisibility.bind(this)}></div>
                {this.renderMeter()}
            </label>
        );
    }
}

PasswordFieldComponent.defaultProps = {
    showMeter: true
}

PasswordFieldComponent.propTypes = {
    formField: React.PropTypes.object.isRequired
};

export default PasswordFieldComponent;



/** WEBPACK FOOTER **
 ** ./app/src/components/PasswordFieldComponent.js
 **/